import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-privacy-policy-cz',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './privacy-policy-cz.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyCzComponent {
  @Input() effectiveDate!: string;
  @Input() version!: string;
  @Input() supportEmail!: string;
  @Input() websiteUrl!: string;
  @Input() jobPortalUrl!: string;
}
